import { useTranslation } from "react-i18next";
import IAudienceFieldProps from "./IAudienceFieldProps";
import IGroup from "../../../../models/IGroup";
import { Combobox, Option, OptionOnSelectData, Persona, SelectionEvents } from "@fluentui/react-components";
import { Col, Row } from "react-grid-system";
import useStyleUtils from "../../../../utilities/styles";

const Group = (props: { group: IGroup }) => {
    const { t } = useTranslation();
    const { group } = props;

    const secondaryText = group.description && group.description.toLowerCase() !== group.name.toLowerCase()
        ? group.description
        : t("general.noDescription");

    return (
        <Option text={group.name} value={group.id}>
            <Persona name={group.name} secondaryText={secondaryText} />
        </Option>
    );
};

export default function AudienceField(props: IAudienceFieldProps) {
    const style = useStyleUtils();

    const selectedIds = props.selectedGroups.map((group) => group.id);

    const onSelect = (_: SelectionEvents, data: OptionOnSelectData) => {
        const selectedGroups = data.selectedOptions.map((option) => props.groups.find((group) => group.id === option) as IGroup);
        props.onSelect(selectedGroups);
    };

    return (
        <Row className={style.mb3}>
            <Col>
                <Combobox multiselect
                    onOptionSelect={onSelect}
                    selectedOptions={selectedIds}
                    placeholder={props.placeholder}>
                    {
                        props.groups.map((group: IGroup) => <Group key={group.id} group={group} />)
                    }
                </Combobox>
            </Col>
        </Row>
    );
}